import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import styles from './WizardImageCard.module.scss';
import Text from '../../../../BaseModule/Components/Text';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.IMAGE_CARD }>;
}

const WizardImageCard: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			<img
				src={item.settings.imageUrl}
				alt={item.title}
				className={styles.baseImage}
			/>
			<div className={styles.card}>
				<img
					src={item.settings.iconUrl}
					className={styles.icon}
					alt='green check'
				/>
				<Text tx={item.title} className={styles.header} />
				<Text tx={item.value} className={styles.normal} noEscape />
			</div>
		</div>
	);
};

export default WizardImageCard;
